<div class="flex flex-col justify-start items-center w-full h-screen">
    <app-bar class="w-full"></app-bar>
    <div class="w-full" style="flex: 1">
        <router-outlet></router-outlet>
    </div>
</div>

<!-- <fm-people-list class="w-full"></fm-people-list> -->
